import React, { useEffect, useMemo, useRef, useState } from "react"
import PubNub from "pubnub"
import { Helmet } from "react-helmet"
import { Card } from "../../components/Card"
import { Button } from "../../components/Button"
import { Input, Label, SelectInput } from "../../components/Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { platformDetails } from "../../core/utils/platformDetails"
import { Section } from "../../components/Section"
import { ChannelsList, ChatMessageHeader, isObjectEffectivelyEmpty, SendMessage } from "../../components/NewChatComponents"
import { SectorAutomationContainer } from "../../container/SectorAutomationContainer"
import SendMagicLinkContainer from "../../container/SendMagicLinkContainer"
import { SendTermsOfUseContainer } from "../../container/SendTermsOfUseContainer"
import MessageNewsContainer from "../../container/MessageNewsContainer"
import MessageContainer from "../../container/MessageContainer"
import { useChatContext } from "../../core/context/chatContext"
import { ButtonClose } from "../../components/ChatCloseButton"
import { InfoTooltip } from "../../components/Tooltip"
import { isMobile } from "react-device-detect"
import "./styles.scss"
import { useDispatch, useSelector } from "react-redux"
import { setData } from "../../core/redux/app/Actions"
import TagContainer from "../../container/TagContainer"
import { FilterModalContent } from "../FarmerScreen"
import { useLocation } from "react-router-dom"
import Overlay from "../../components/Overlay"
import { NewAssistanceModalConfirm } from "../../components/NewAssistanceModalConfirm"

const ModalTestimonialSaveConfirm = ({
  openModalTestimonialSave,
  handleCloseModalTestimonialSave,
  projectsList,
  handleSelectProject,
}) => {
  return (
    <ModalPanel modalIsOpen={openModalTestimonialSave}>
      <ModalHeader title="Salvar Destaque" closeModal={handleCloseModalTestimonialSave} />
      <ModalBody>
        <div className="modal-testimonial">
          <div className="modal-testimonial__select">
            <span className="modal-testimonial__title">Para qual projeto deseja salvar ?</span>
            <div className="modal-testimonial__select-menu">
              <SelectInput
                options={projectsList}
                placeholder="Selecione um projeto"
                handleChange={handleSelectProject}
                isOverModal={true}
              />
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalPanel>
  )
}

const checkUsersByPinnedMessages = (pinnedMessages, userId) => {
  return pinnedMessages.some((obj) => obj?.user !== userId)
}

const ActionsModal = ({
  chat,
  pinnedMessages,
  sectorModalIsOpen,
  setSectorModalIsOpen,
  messageModalIsOpen,
  setMessageModalIsOpen,
  modalNewsIsOpen,
  setModalNewsIsOpen,
  modalTermsIsOpen,
  setModalTermsIsOpen,
  modalMagicLinkIsOpen,
  setModalMagicLinkIsOpen,
  tagLinkIsOpen,
  setModalTagLinkIsOpen,
}) => {
  const { isScheduleOpen, handleOpenSchedule, handleCloseSchedule } = useChatContext()
  const setModalIsOpen = (open) => (open ? handleOpenSchedule(open) : handleCloseSchedule())
  const selectedUsers =
    chat && Array.isArray(chat?.projectNames)
      ? [{ ...chat, projectId: chat?.projectIds[0], project: chat?.projectNames[0] }]
      : []
  return (
    <>
      <SectorAutomationContainer
        isChatContainer={true}
        selectedsUsers={selectedUsers}
        setSectorModalIsOpen={setSectorModalIsOpen || setModalIsOpen}
        sectorModalIsOpen={sectorModalIsOpen || isScheduleOpen}
        pinnedMessages={pinnedMessages}
      />
      {messageModalIsOpen && (
        <MessageContainer
          isChatContainer={true}
          setMessageModalIsOpen={setMessageModalIsOpen}
          messageModalIsOpen={messageModalIsOpen}
          selectedsUsers={selectedUsers}
        />
      )}
      {modalNewsIsOpen && (
        <MessageNewsContainer
          selectedsUsers={selectedUsers}
          setModalNewsIsOpen={setModalNewsIsOpen}
          modalNewsIsOpen={modalNewsIsOpen}
        />
      )}
      {modalTermsIsOpen && (
        <SendTermsOfUseContainer
          modalTermsIsOpen={modalTermsIsOpen}
          setModalTermsIsOpen={setModalTermsIsOpen}
          isChatContainer={true}
          selectedUsers={selectedUsers}
          pinnedMessages={pinnedMessages}
        />
      )}
      {modalMagicLinkIsOpen && (
        <SendMagicLinkContainer
          setModalMagicLinkIsOpen={setModalMagicLinkIsOpen}
          modalMagicLinkIsOpen={modalMagicLinkIsOpen}
          selectedsUsers={selectedUsers}
        />
      )}
      {tagLinkIsOpen && (
        <TagContainer
          users={selectedUsers}
          isChatContainer={true}
          tagIsOpen={tagLinkIsOpen}
          setTagIsOpen={setModalTagLinkIsOpen}
        />
      )}
    </>
  )
}

const CustomCard = ({ children, className, showOnlyChat }) => {
  return showOnlyChat ? (
    <Section className={className}>{children}</Section>
  ) : (
    <Card className={className}>{children}</Card>
  )
}

function NewChatScreen({
  handleToggleSystemChat,
  isSystemChat,
  showOnlyChat,
  loggedUser,
  handleLoadMoreChannels,
  onChangeFilterMessages,
  debouncedInputMessage,
  openHistory,
  setOpenHistory,
  openSearch,
  setOpenSearch,
  setMessageModalIsOpen,
  messageModalIsOpen,
  modalNewsIsOpen,
  setModalNewsIsOpen,
  modalTermsIsOpen,
  setModalTermsIsOpen,
  modalMagicLinkIsOpen,
  setModalMagicLinkIsOpen,
  openModalTestimonialSave,
  handleCloseModalTestimonialSave,
  projectsList,
  handleSelectProject,
  tagLinkIsOpen,
  setModalTagLinkIsOpen,
  chat,
  setChat,
  tab,
  tabOptions,
  onSendMessages,
  onKeyPress,
  channels,
  messages,
  onChange,
  onChangeFilterTags,
  loading,
  setOpenPicker,
  openPicker,
  onDeleteMessage,
  uploadFiles,
  newChat,
  unreadMessage,
  onTab,
  createdAt,
  setRead,
  read,
  modalFilterIsOpen,
  setModalFilterIsOpen,
  tags,
  selectedTag,
  selectedTagSecondFilter,
  loadTags,
  tagsToFilter,
  handleTagsToFilter,
  numberOfChats,
  onChangeMessage,
  onQuickFilterClick,
  isQuickFilterActive,
  inputMessage,
  valueSearch,
  endChat,
  isFinished,
  goToElementId,
  filteredMsgPosition,
  showActions,
  handleOpenAssistance,
  openNewAssistance,
  setOpenText,
  openText,
  setOpenVoice,
  openVoice,
  generateAccessLink,
  resendMessage,
  handleTestimonial,
  handleCloseModal,
  formQuestionMessage,
  reload,
  values,
  clearFields,
  resetFields,
  handleNewAssitanceConfirm,
  register,
  watch,
  isMobile,
  handleNavigateToEvidence = () => { },
  handleRemoveTestimonial,
  onEditUser
}) {
  const {
    handleOpenSchedule,
    pinnedMessages,
    resetPinnedMessages,
    resetPinnedMessagesQuestions,
    pinnedMessagesQuestions,
    saveOnlyMessage,
    evidenceId,
    isLoadingTestimonial,
    chatOpenScreen,
    channelLoading,
    moreChannelLoading,
    isLoadingMessages,
    enabledIntegration
  } = useChatContext()

  const testimonialSaveDisabled = checkUsersByPinnedMessages(pinnedMessages, chat?.id)

  let messagePosition = filteredMsgPosition
  const listRef = useRef()
  const rowHeights = useRef({})
  const { platformName } = platformDetails()
  const dispatch = useDispatch()
  const closeModalChat = useSelector((state) => state.app.closeModalChat)
  const location = useLocation();

  useEffect(() => {
    dispatch(
      setData({
        chat: false,
      }),
    )
  }, [])

  useEffect(() => {
    if (filteredMsgPosition) {
      messagePosition = filteredMsgPosition
    }
  }, [filteredMsgPosition])

  const getRowHeight = (index) => {
    return rowHeights.current[index] + 16 || 100
  }

  const setRowHeight = (index, size) => {
    rowHeights.current[index] = size || 100
    if (listRef.current) {
      listRef.current.getInternalRef()?.resetAfterIndex(index)
    }
  }

  const generateMenuItem = (label, onClick) => {
    return {
      label,
      onClick,
    }
  }
  const handleCloseChat = () => {
    dispatch(
      setData({
        closeModalChat: !closeModalChat,
      }),
    )
  }

  const goToFiltered = (direction = "up") => {
    if (!messagePosition.messages || !messagePosition.messages.length) {
      return
    }

    let currentPosition = messagePosition.index
    currentPosition = messagePosition.messages.findIndex((row) => row.position === currentPosition)

    if (direction === "up") {
      if (currentPosition) {
        currentPosition = messagePosition.messages.slice(0, currentPosition)
        currentPosition = currentPosition[currentPosition.length - 1]?.position

        if (currentPosition >= 0) {
          messagePosition = { ...filteredMsgPosition, index: currentPosition }
          listRef.current.getInternalRef()?.scrollToRow(currentPosition)
        }
      }
    } else {
      currentPosition = messagePosition.messages.slice(currentPosition + 1)
      currentPosition = currentPosition[0]?.position

      if (currentPosition >= 0) {
        messagePosition = { ...filteredMsgPosition, index: currentPosition }
        listRef.current.getInternalRef()?.scrollToRow(currentPosition)
      }
    }
  }

  const menuList = [
    !location.pathname.startsWith("/farmer/profile/") &&
    generateMenuItem(
      isFinished ? "Iniciar conversa" : "Finalizar conversa",
      () => endChat()
    ),

    generateMenuItem("Pesquisar", () => setOpenSearch(true)),
    generateMenuItem("Enviar comunicação", () => setModalTermsIsOpen(true)),
    generateMenuItem("Vincular tag", () => setModalTagLinkIsOpen(true)),
  ].filter(Boolean);

  const tagsException = useMemo(() => {
    let updatedTags = tags

    if (values?.tag?.length) {
      updatedTags = updatedTags?.filter(
        (obj) =>
          !values?.tag?.some(
            (criteria) => criteria.value === obj.value && criteria.label === obj.label,
          ),
      )
    }

    return updatedTags
  }, [tags, values?.tag]) // Adicione as dependências necessárias

  return (
    <div className="content-container">
      <Helmet>
        {unreadMessage === 0 || unreadMessage === "" ? (
          <title>{platformName}</title>
        ) : (
          <title>{`(${unreadMessage}) ${platformName}`}</title>
        )}
      </Helmet>
      <CustomCard className="card-chat" showOnlyChat={showOnlyChat}>
        <ViewChat
          handleToggleSystemChat={handleToggleSystemChat}
          isSystemChat={isSystemChat}
          showOnlyChat={showOnlyChat}
          isMobile={isMobile}
          loggedUser={loggedUser}
          handleLoadMoreChannels={handleLoadMoreChannels}
          moreChannelLoading={moreChannelLoading}
          onChangeFilterMessages={onChangeFilterMessages}
          openHistory={openHistory}
          setOpenHistory={setOpenHistory}
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
          chat={chat}
          setChat={setChat}
          tab={tab}
          tabOptions={tabOptions}
          onSendMessages={onSendMessages}
          onKeyPress={onKeyPress}
          channels={channels}
          messages={messages}
          onChange={onChange}
          values={values}
          loading={loading}
          channelLoading={channelLoading}
          setOpenPicker={setOpenPicker}
          openPicker={openPicker}
          onDeleteMessage={onDeleteMessage}
          uploadFiles={uploadFiles}
          newChat={newChat}
          onTab={onTab}
          createdAt={createdAt}
          setRead={setRead}
          read={read}
          setModalFilterIsOpen={setModalFilterIsOpen}
          numberOfChats={numberOfChats}
          onChangeMessage={onChangeMessage}
          onQuickFilterClick={onQuickFilterClick}
          isQuickFilterActive={isQuickFilterActive}
          inputMessage={inputMessage}
          valueSearch={valueSearch}
          goToElementId={goToElementId}
          showActions={showActions}
          handleOpenAssistance={handleOpenAssistance}
          setOpenText={setOpenText}
          openText={openText}
          setOpenVoice={setOpenVoice}
          openVoice={openVoice}
          resendMessage={resendMessage}
          menuList={menuList}
          pinnedMessages={pinnedMessages}
          resetPinnedMessages={resetPinnedMessages}
          goToFiltered={goToFiltered}
          setRowHeight={setRowHeight}
          getRowHeight={getRowHeight}
          listRef={listRef}
          handleOpenSchedule={handleOpenSchedule}
          testimonialSaveDisabled={testimonialSaveDisabled}
          handleTestimonial={handleTestimonial}
          dispatch={dispatch}
          formQuestionMessage={formQuestionMessage}
          handleCloseChat={handleCloseChat}
          handleCloseModal={handleCloseModal}
          handleNavigateToEvidence={handleNavigateToEvidence}
          reload={reload}
          pinnedMessagesQuestions={pinnedMessagesQuestions}
          resetPinnedMessagesQuestions={resetPinnedMessagesQuestions}
          handleRemoveTestimonial={handleRemoveTestimonial}
          evidenceId={evidenceId}
          saveOnlyMessage={saveOnlyMessage}
          isLoadingTestimonial={isLoadingTestimonial}
          outSideContainer={chatOpenScreen}
          isLoadingMessages={isLoadingMessages}
          enabledIntegration={enabledIntegration}
          onEditUser={onEditUser}
        />
      </CustomCard>
      <ActionsModal
        {...{
          chat,
          pinnedMessages,
          setMessageModalIsOpen,
          messageModalIsOpen,
          setMessageModalIsOpen,
          modalNewsIsOpen,
          setModalNewsIsOpen,
          modalTermsIsOpen,
          setModalTermsIsOpen,
          modalMagicLinkIsOpen,
          setModalMagicLinkIsOpen,
          tagLinkIsOpen,
          setModalTagLinkIsOpen,
        }}
      />
      <FilterModalContent
        {...{
          modalIsOpen: modalFilterIsOpen,
          setModalIsOpen: setModalFilterIsOpen,
          tagsOptions: tags,
          tagException: tagsException,
          onChangeFilter: onChangeFilterTags,
          selectedTag,
          selectedTagSecondFilter,
          filter: values,
          channelLoading,
          handleTagsToFilter,
          handleApplyFilter: loadTags,
          isFilterLoading: channelLoading,
          tagsToFilter,
          clearFields,
          resetFields,
          isFarmerProfile: false,
        }}
      />

      {openModalTestimonialSave && (
        <ModalTestimonialSaveConfirm
          {...{
            openModalTestimonialSave,
            handleCloseModalTestimonialSave,
            projectsList,
            handleSelectProject,
          }}
        />
      )}

      {openNewAssistance && (
        <NewAssistanceModalConfirm
          {...{
            openNewAssistance,
            handleOpenAssistance,
            handleNewAssitanceConfirm,
            register,
            watch,
          }}
        />
      )}
    </div>
  )
}

export default NewChatScreen

const currentChannel = "Default"
const theme = "light"
const pubnubData = new PubNub({
  publishKey: "pub-c-522c83d7-f96e-44fd-8152-e19184ca296a",
  subscribeKey: "sub-c-02d0ce14-bf0b-11ec-bd2a-8ab19e3fdcf0",
  uuid: "sec-c-MWQ2NjMwMjgtN2I2Zi00ZWFkLTkzNTgtMGZiMjkyZjEyMjcw",
})

const ViewChat = ({
  handleToggleSystemChat,
  isSystemChat,
  showOnlyChat,
  loggedUser,
  handleLoadMoreChannels,
  moreChannelLoading,
  onChangeFilterMessages,
  openHistory,
  setOpenHistory,
  openSearch,
  setOpenSearch,
  chat,
  setChat,
  tab,
  tabOptions,
  onSendMessages,
  onKeyPress,
  channels,
  messages,
  onChange,
  values,
  loading,
  channelLoading,
  setOpenPicker,
  openPicker,
  onDeleteMessage,
  uploadFiles,
  newChat,
  onTab,
  createdAt,
  setRead,
  read,
  setModalFilterIsOpen,
  numberOfChats,
  onChangeMessage,
  onQuickFilterClick,
  isQuickFilterActive,
  inputMessage,
  valueSearch,
  goToElementId,
  showActions,
  handleOpenAssistance,
  handleOpenSchedule,
  setOpenText,
  openText,
  setOpenVoice,
  openVoice,
  resendMessage,
  menuList,
  pinnedMessages,
  resetPinnedMessages,
  resetPinnedMessagesQuestions,
  goToFiltered,
  setRowHeight,
  getRowHeight,
  listRef,
  testimonialSaveDisabled,
  handleTestimonial,
  handleCloseModal,
  dispatch,
  formQuestionMessage,
  handleCloseChat,
  reload,
  handleNavigateToEvidence = () => { },
  pinnedMessagesQuestions,
  evidenceId,
  saveOnlyMessage,
  handleRemoveTestimonial,
  isLoadingTestimonial,
  outSideContainer,
  isLoadingMessages,
  enabledIntegration,
  onEditUser
}) => {
  return isMobile && !showOnlyChat ? (
    <div className="content-sidebar" style={{ display: "flex", flex: 1, height: "100%" }}>
      {!chat ? (
        <div className="sidebar-group" style={{ width: "100%" }}>
          <div className="sidebar-chat active" style={{ width: "100%" }}>
            <header>
              <span>
                Chat (
                {values?.tag?.length > 0 || values?.tagException?.length > 0 || isQuickFilterActive
                  ? channels?.length
                  : numberOfChats["active"]}
                )
              </span>
            </header>
            <div className="sidebar-chat-filter">
              <Input
                placeholder="Pesquise pelo nome"
                hasIcon={<i class="fi fi-rr-search"></i>}
                hasFocus={false}
                onChange={(event) => onChange("search", { value: event.target.value })}
                handleClick={() => setModalFilterIsOpen(true)}
              />
              <button
                className={`quick-filter-button ${isQuickFilterActive ? 'active' : ''}`}
                onClick={onQuickFilterClick}
                title="Filtrar conversas com meu nome"
              >
                <i className="fi fi-rr-user"></i>
              </button>
            </div>
            <div className="sidebar-chat-tabs">
              <ul class="tabs" role="tablist">
                <li
                  class={`not_answer ${!read ? "active" : "inactive"} tab`}
                  id="unanswered"
                  role="tab"
                  aria-controls="unanswered">
                  <div onClick={() => setRead(false)}>Abertos</div>
                </li>
                <li
                  class={`answer ${read ? "active" : "inactive"} tab`}
                  id="answered"
                  role="tab"
                  aria-controls="answered">
                  <div onClick={() => setRead(true)}>Fechado</div>
                </li>
                <li class="slider" role="presentation"></li>
              </ul>
            </div>
          </div>
          <div
            className={`sidebar-body ${!read ? "open" : "finished"}`}
            style={!read ? { top: "195px" } : {}}>
            <ChannelsList
              selectedChat={chat}
              onSelectChat={(item) => {
                setChat(item)
                dispatch(
                  setData({
                    chat: item,
                    headerIsntNeeded: true,
                  }),
                )
              }}
              onTab={(tab) => onTab(tab)}
              tab={tab}
              tabOptions={tabOptions}
              channels={channels}
              onChange={(event) => onChange("search", { value: event.target.value })}
              loading={channelLoading}
              setRead={setRead}
              read={read}
              handleClick={() => setModalFilterIsOpen(true)}
              values={values}
              onEditUser={onEditUser}
            />
            {!channelLoading && read && (
              <div className="load-more__container">
                <Button
                  label="Carregar mais"
                  variant="outline"
                  color="new_green"
                  handleClick={handleLoadMoreChannels}
                  isDisabled={moreChannelLoading}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={`chat ${isSystemChat ? "system_version" : ""}`}>
          <Overlay loading={isLoadingTestimonial} />
          {chat && (
            <>
              <ChatMessageHeader
                {...{
                  chat,
                  menuList,
                  openHistory,
                  setOpenHistory,
                  openSearch,
                  setOpenSearch,
                  goToElementId,
                  formQuestionMessage,
                  goToFiltered,
                  showOnlyChat,
                  handleToggleSystemChat,
                  isSystemChat,
                  handleCloseChat,
                  handleNavigateToEvidence,
                  backToList: () => {
                    setChat(false)
                    dispatch(
                      setData({
                        chat: false,
                      }),
                    )
                  },
                }}
                onChange={onChangeFilterMessages}
                selectedChat={chat}
                loggedUser={loggedUser}
              />
              {isMobile && !isSystemChat ? (
                <div className="div-profile">
                  <div className="avatar user-chat-avatar">
                    <div className="avatar-img">
                      <img
                        className="img-avatar"
                        src={
                          chat.image
                            ? chat.image
                            : `https://ui-avatars.com/api/?background=random&name=${chat?.name}`
                        }
                      />
                    </div>
                  </div>
                  <div className="name">{chat.name}</div>
                </div>
              ) : null}
              <div class="scrollbar-container">
                <div class="chat-body">
                  <div class="messages">
                    {
                      <SendMessage
                        chat={chat}
                        theme={theme}
                        pubnub={pubnubData}
                        currentChannel={currentChannel}
                        selectedChat={chat}
                        onSend={onSendMessages}
                        onKeyPress={onKeyPress}
                        messages={messages}
                        loggedUser={loggedUser}
                        onSendFile={(file) => uploadFiles(file)}
                        onChangeVoic={(value, file) => onChange("audio", { value, file })}
                        valueVoic={values && values.audio && values.audio.value}
                        loading={loading}
                        setOpenPicker={setOpenPicker}
                        openPicker={openPicker}
                        onDeleteMessage={(item) => onDeleteMessage(item)}
                        newChat={newChat}
                        createdAt={createdAt}
                        valueSearch={valueSearch}
                        ref={listRef}
                        setRowHeight={setRowHeight}
                        getRowHeight={getRowHeight}
                        isSystemChat={isSystemChat}
                        showActions={showActions}
                        withoutProfile={showOnlyChat}
                        onChangeMessage={onChangeMessage}
                        valueMessage={inputMessage || ""}
                        handleOpenText={setOpenText}
                        openText={openText}
                        handleOpenVoice={setOpenVoice}
                        openVoice={openVoice}
                        resendMessage={resendMessage}
                        formQuestionMessage={formQuestionMessage}
                        handleTestimonial={handleTestimonial}
                        handleRemoveTestimonial={handleRemoveTestimonial}
                        reload={reload}
                        outSideContainer={outSideContainer}
                        isLoadingMessages={isLoadingMessages}
                        enabledIntegration={enabledIntegration}
                      />
                    }
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  ) : (
    <div className="content-sidebar">
      <div className="sidebar-group" style={showOnlyChat ? { display: "none" } : {}}>
        <div className="sidebar-chat active">
          <header>
            <span>Chat</span>
          </header>
          <div className="sidebar-chat-filter">
            <Input
              placeholder="Pesquise pelo nome"
              hasIcon={<i className="fi fi-rr-search"></i>}
              hasFocus={false}
              onChange={(event) => onChange("search", { value: event.target.value })}
              handleClick={() => setModalFilterIsOpen(true)}
            />
            <button
              className={`quick-filter-button ${isQuickFilterActive ? 'active' : ''}`}
              onClick={onQuickFilterClick}
              title="Filtrar conversas com meu nome"
            >
              <i className="fi fi-rr-user"></i>
            </button>
          </div>
          <div className="sidebar-chat-tabs">
            <ul class="tabs" role="tablist">
              <li
                class={`not_answer ${!read ? "active" : "inactive"} tab`}
                id="unanswered"
                role="tab"
                aria-controls="unanswered">
                <div onClick={() => setRead(false)}>
                  Abertos (
                  {values?.tag?.length > 0 || values?.tagException?.length > 0 || isQuickFilterActive
                    ? channels?.length
                    : numberOfChats["active"]}
                  )
                </div>
              </li>
              <li
                class={`answer ${read ? "active" : "inactive"} tab`}
                id="answered"
                role="tab"
                aria-controls="answered">
                <div onClick={() => setRead(true)}>Finalizados</div>
              </li>
              <li class="slider" role="presentation"></li>
            </ul>
          </div>
        </div>
        <div
          className={`sidebar-body ${!read ? "open" : "finished"}`}
          style={!read ? { top: "195px" } : {}}>
          <ChannelsList
            selectedChat={chat}
            onSelectChat={(item) => setChat(item)}
            onTab={(tab) => onTab(tab)}
            tab={tab}
            tabOptions={tabOptions}
            channels={channels}
            onChange={(event) => onChange("search", { value: event.target.value })}
            loading={channelLoading}
            setRead={setRead}
            read={read}
            handleClick={() => setModalFilterIsOpen(true)}
            values={values}
            onEditUser={onEditUser}
          />
          {!channelLoading && read && (
            <div className="load-more__container">
              <Button
                label="Carregar mais"
                variant="outline"
                color="new_green"
                handleClick={handleLoadMoreChannels}
                isDisabled={moreChannelLoading}
              />
            </div>
          )}
        </div>
      </div>
      <div className={`chat ${isSystemChat ? "system_version" : ""}`}>
        <Overlay loading={isLoadingTestimonial} />
        {/* <ChatMessageHeader
          {...{
            chat,
            menuList,
            openHistory,
            setOpenHistory,
            openSearch,
            setOpenSearch,
            goToElementId,
            goToFiltered,
            showOnlyChat,
            handleToggleSystemChat,
            isSystemChat,
          }}
          onChange={onChangeFilterMessages}
          selectedChat={chat}
          loggedUser={loggedUser}
        /> */}
        {chat && (
          <>
            <ChatMessageHeader
              {...{
                chat,
                menuList,
                openHistory,
                setOpenHistory,
                openSearch,
                setOpenSearch,
                goToElementId,
                goToFiltered,
                showOnlyChat,
                handleToggleSystemChat,
                isSystemChat,
                formQuestionMessage,
                handleCloseChat,
                handleNavigateToEvidence,
              }}
              handleCloseModal={handleCloseModal}
              onChange={onChangeFilterMessages}
              selectedChat={chat}
              loggedUser={loggedUser}
              handleCloseChat={handleCloseChat}
              outSideContainer={outSideContainer}
            />
            <div class="scrollbar-container">
              <div class="chat-body">
                <div class="messages">
                  <SendMessage
                    chat={chat}
                    theme={theme}
                    pubnub={pubnubData}
                    currentChannel={currentChannel}
                    selectedChat={chat}
                    onSend={onSendMessages}
                    onKeyPress={onKeyPress}
                    messages={messages}
                    loggedUser={loggedUser}
                    onSendFile={(file) => uploadFiles(file)}
                    onChangeVoic={(value, file) => onChange("audio", { value, file })}
                    valueVoic={values && values.audio && values.audio.value}
                    loading={loading}
                    setOpenPicker={setOpenPicker}
                    openPicker={openPicker}
                    onDeleteMessage={(item) => onDeleteMessage(item)}
                    newChat={newChat}
                    createdAt={createdAt}
                    valueSearch={valueSearch}
                    ref={listRef}
                    setRowHeight={setRowHeight}
                    getRowHeight={getRowHeight}
                    isSystemChat={isSystemChat}
                    showActions={showActions}
                    withoutProfile={showOnlyChat}
                    onChangeMessage={onChangeMessage}
                    valueMessage={inputMessage || ""}
                    handleOpenText={setOpenText}
                    openText={openText}
                    handleOpenVoice={setOpenVoice}
                    openVoice={openVoice}
                    resendMessage={resendMessage}
                    formQuestionMessage={formQuestionMessage}
                    handleRemoveTestimonial={handleRemoveTestimonial}
                    handleTestimonial={handleTestimonial}
                    outSideContainer={outSideContainer}
                    reload={reload}
                    isLoadingMessages={isLoadingMessages}
                    enabledIntegration={enabledIntegration}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {pinnedMessagesQuestions &&
          pinnedMessagesQuestions?.[`${evidenceId}-messages`]?.length > 0 && (
            <div className="chat_message_actions">
              <span className="action_title">
                {pinnedMessagesQuestions?.[`${evidenceId}-messages`]?.length || 0} mensagens
              </span>
              <div className="actions_box">
                <InfoTooltip
                  info="Adicionar Evidência"
                  trigger="hover"
                  icon="fi-sr-pin"
                  children={
                    <button className="message-pin" onClick={() => handleNavigateToEvidence()} />
                  }
                />
                <ButtonClose handleClick={() => resetPinnedMessagesQuestions(evidenceId)} />
              </div>
            </div>
          )}
      </div>
    </div>
  )
}
